import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import "./cancelOrder.css";


const Eyebrow = ({ text, variant }) => (
  <div className={`co__eyebrow ${variant === "success" ? "co__eyebrow--success" : ""}`}>
    <span className="co__eyebrow-rule" />
    <span className="co__eyebrow-diamond">◆</span>
    <span className="co__eyebrow-text">{text}</span>
    <span className="co__eyebrow-diamond">◆</span>
    <span className="co__eyebrow-rule" />
  </div>
);

const SuccessCancelPage = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const reduxShowName = useSelector((state) => state.reservation.showName);

  const firstName = location.state?.firstName || "";
  const showName = location.state?.showName || reduxShowName || "";
  const externalPlatform = location.state?.externalPlatform;
  const showExternalPlatform =
    externalPlatform?.showPowerBy && externalPlatform?.name;

  return (
    <div className="co">
      <header className="co__header">
        <span className="co__brand">{showName}</span>
      </header>

      <main className="co__main">
        <div className="co__container">
          <div className="co__state">
            <div className="co__status-icon co__status-icon--success">
              <svg viewBox="0 0 24 24">
                <polyline points="20 6 9 17 4 12" />
              </svg>
            </div>
            <Eyebrow
              text={t("cancelReservation.successEyebrow")}
              variant="success"
            />
            <h1 className="co__title">{t("cancelReservation.successTitle")}</h1>
            <p className="co__subtitle">
              {firstName
                ? t("cancelReservation.successSubtitleNamed", { firstName })
                : t("cancelReservation.successSubtitle")}
            </p>
          </div>
        </div>
      </main>

      <footer className="co__footer">
        <p className="co__footer-powered">
          Powered by Wellet
          {showExternalPlatform ? ` · ${externalPlatform.name}` : ""}
        </p>
      </footer>
    </div>
  );
};

export default SuccessCancelPage;
